import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Period } from 'src/app/assabil-kernel/models/entities/control-tables/period';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PeriodRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/period-request';


@Component({
  selector: 'period-list',
  templateUrl: './period-list.component.html',
  styleUrls: ['./period-list.component.scss']
})
export class PeriodListComponent extends BasePage2<Period> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  startDate : Date;
  endDate : Date;
  workingDays : number;
  calculationStartDate : Date;
  calculationEndDate : Date;
  referenceStartDate : Date;
  referenceEndDate : Date;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  periods: Period[] = [];
  // ---------------------------------------------------
  
  //----------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName  = 'period';
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------

  listFields = [
      { prop: 'periodCode',             name: 'Code',  insertOnly : true},
      { prop: 'name',                   name: 'Name' },
      { prop: 'active',                 name: 'Active',                     type:'boolean'},
      { prop: 'closed',                 name: 'Fermée',                     type:'boolean'},
      { prop: 'startDate',              name: 'Date debut',                 type:'date'  },
      { prop: 'endDate',                name: 'Date fin',                   type:'date'  },
      { prop: 'workingDays',            name: 'Jours ouvrables',            type:'number'},
      { prop: 'calculationStartDate',   name: 'Date debut de calcul',       type:'date'  },
      { prop: 'calculationEndDate',     name: 'Date fin de calcul',         type:'date'  },
      { prop: 'referenceStartDate',     name: 'Date debut de reference',    type:'date'  },
      { prop: 'referenceEndDate',       name: 'Date fin de reference',      type:'date'  },

  ]
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------

  getRows(): Period[] {
      return this.periods;
  }
  
  //----------------------------------------------------------------------

  
  //----------------------------------------------------------------------
    new(){
        let entity : Period = new Period();
        entity.inserted = true;
        entity.edit = true;
        this.periods.push(entity);
        this.periods = [...this.periods];
        }
   //----------------------------------------------------------------------

       

//----------------------------------------------------------------------
saveRow(period: Period): Promise<Period> {
    let request  : PeriodRequest = new PeriodRequest(this.controlService.getUserInfo());
    request.period = period;
      return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.periods = result;
        
    })
}
//----------------------------------------------------------------------

}


